import { render } from "./ChatRoomInput.vue?vue&type=template&id=3b69ff2e"
import script from "./ChatRoomInput.vue?vue&type=script&lang=js"
export * from "./ChatRoomInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__